import type { TaskSearchRequestDto } from '../types/search-request.dto';
import type { TaskSearchRequestModel } from '../types/search-request.model';

import { toSearchRequestDto } from '@/features/Shared/model/mappers/search-request.dt';

export const toTaskSearchRequestDto = (model: TaskSearchRequestModel): TaskSearchRequestDto => {
	return {
		...toSearchRequestDto(model),
		title: model.title,
	};
};
